import React from 'react';
import { navigate } from "gatsby";
import { useLocale } from '../../hooks/locale';

import * as S from './styled';

const Languages = () => {
  // Grab the locale (passed through context) from the Locale Provider 
  // through useLocale() hook
  const { locale } = useLocale();
  const languages = [
    { key: "bg", value: "БГ" }, 
    { key: "en", value: "EN" },
    { key: "de", value: "DE" }
  ];
// 
  function handleClickLanguage(e, lang) {
    e.preventDefault();
    if (locale === lang) return;

    const chunk = window.location.pathname.split("/").pop();
    const prefix = lang === "bg" ? "" : `${lang}/`;
    const page = !chunk ? "" : chunk;
    return navigate(`/${prefix}${page}`);
  }

  return (
    <S.LanguageWrapper>
      {languages.map(lang => (
          <S.LanguageItem key={`lang-${lang.key}`}>
            <S.LanguageLink 
              to="/" 
              onClick={(e) => handleClickLanguage(e, lang.key)}
              className={locale === lang.key ? 'is-active' : ''}
            >
            {lang.value}
          </S.LanguageLink>
        </S.LanguageItem>
        ))
      }
    </S.LanguageWrapper>
  );
};

export default Languages;
